/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogListingFragment, BlogListingFragment, FullBlogListingFragment} from '@amblique/contentful/app/contentful/fragments/blog-listing';

/**
 * Get a single BlogListing by ID (base - scalars only)
 */
export const getBaseBlogListingById = gql`
  ${BaseBlogListingFragment}

  query GetBaseBlogListingById($id: String!, $locale: String!, $preview: Boolean) {
    blogListing(id: $id, locale: $locale, preview: $preview) {
      ...BaseBlogListingFragment
    }
  }
`;

/**
 * Get a single BlogListing by ID (standard - 1 level deep)
 */
export const getBlogListingById = gql`
  ${BlogListingFragment}

  query GetBlogListingById($id: String!, $locale: String!, $preview: Boolean) {
    blogListing(id: $id, locale: $locale, preview: $preview) {
      ...BlogListingFragment
    }
  }
`;

/**
 * Get a single BlogListing by ID (full - 2 levels deep)
 */
export const getFullBlogListingById = gql`
  ${FullBlogListingFragment}

  query GetFullBlogListingById($id: String!, $locale: String!, $preview: Boolean) {
    blogListing(id: $id, locale: $locale, preview: $preview) {
      ...FullBlogListingFragment
    }
  }
`;

/**
 * Get all BlogListing entries with pagination (base - scalars only)
 */
export const getBaseBlogListings = gql`
  ${BaseBlogListingFragment}

  query GetBaseBlogListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogListingOrder]
    $where: BlogListingFilter
    $preview: Boolean
  ) {
    blogListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBlogListingFragment
      }
    }
  }
`;

/**
 * Get all BlogListing entries with pagination (standard - 1 level deep)
 */
export const getBlogListings = gql`
  ${BlogListingFragment}

  query GetBlogListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogListingOrder]
    $where: BlogListingFilter
    $preview: Boolean
  ) {
    blogListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BlogListingFragment
      }
    }
  }
`;

/**
 * Get all BlogListing entries with pagination (full - 2 levels deep)
 */
export const getFullBlogListings = gql`
  ${FullBlogListingFragment}

  query GetFullBlogListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogListingOrder]
    $where: BlogListingFilter
    $preview: Boolean
  ) {
    blogListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBlogListingFragment
      }
    }
  }
`;
